import { Art } from '@/modules/marketing/SiteArt';
import type { ArtProps } from '@/modules/marketing/SiteArt';

/**
 * The illustrations for the platform's features, by the names the pages import.
 *
 * Each is a picture drawn by `scripts/site-art.py` and shown by `SiteArt`; see there for why they
 * are images, why they look the same in both themes and how to change one. The drawings show the
 * mechanism the article describes, never a screen: a screenshot in an article is a promise that the
 * product looks like that, and it stops being true the first time a button moves.
 */

/** A certificate, its days remaining and the ports it can be read on. */
export function SslArt({ priority }: ArtProps = {}) {
  return <Art name="ssl-monitoring" priority={priority} />;
}

/** A zone's records, one of them changed. */
export function DnsArt({ priority }: ArtProps = {}) {
  return <Art name="dns-monitoring" priority={priority} />;
}

/** Checks from outside the network, an incident and its alerts. */
export function MonitorArt({ priority }: ArtProps = {}) {
  return <Art name="monitoring" priority={priority} />;
}

/** Files and a database leaving for a bucket the customer owns, through a signed link. */
export function BackupArt({ priority }: ArtProps = {}) {
  return <Art name="backups" priority={priority} />;
}

/** One platform reaching servers of different distributions over SSH, with no agent. */
export function ServerArt({ priority }: ArtProps = {}) {
  return <Art name="server-management" priority={priority} />;
}

/** A team: an owner, a member, an invitation, and what each person's runs are filed under. */
export function DashboardArt({ priority }: ArtProps = {}) {
  return <Art name="team" priority={priority} />;
}
